export default "__VITE_ASSET__BBymUwpJ__"